import { render, staticRenderFns } from "./RosterPlan2.vue?vue&type=template&id=6ce5fb91&"
import script from "./RosterPlan2.vue?vue&type=script&lang=js&"
export * from "./RosterPlan2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VPagination,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce5fb91')) {
      api.createRecord('6ce5fb91', component.options)
    } else {
      api.reload('6ce5fb91', component.options)
    }
    module.hot.accept("./RosterPlan2.vue?vue&type=template&id=6ce5fb91&", function () {
      api.rerender('6ce5fb91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/Ess/Roster/RosterFormRecord/components/RosterPlan2.vue"
export default component.exports